<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: "EinspeisebeteiligungHeader",
  data: () => ({
    img: require("@/assets/einspeisebeteiligung.png"),
  }),
  computed: {
    ...mapState('einspeisebeteiligung', ['anlagen']),
    ...mapGetters('einspeisebeteiligung', ['anlagenForLatestYear']),
    anlagenFlaeche() {
      return this.anlagenForLatestYear
          .map(a => a.FlaecheAufGemeinde)
          .reduce((acc, cur) => acc + cur, 0)
          .toLocaleString();
    },
    zahlungGesamt() {
      return this.anlagen
          .map(a => a.VerguetungKommune)
          .reduce((acc, cur) => acc + cur, 0)
          .toLocaleString();
    },
  }
}
</script>

<template>
  <v-img :src="img" gradient="180deg, #8C0F7800 0%, #8C0F78 100%">
    <v-row no-gutters class="fill-height pa-2 d-flex align-end">
      <v-col md="4" cols="12" class="text-padding">
        <div class="stats-header white--text">Wind- und/oder PV-<br>Freiflächenanlagen</div>
        <div class="stats-data white--text">{{ anlagenForLatestYear.length }}</div>
      </v-col>
      <v-col md="4" cols="6" class="text-padding">
        <div class="stats-header white--text">Beteiligungsfähige<br>Fläche</div>
        <div class="stats-data white--text">{{ anlagenFlaeche }} m²</div>
      </v-col>
      <v-col md="4" cols="6" class="text-padding">
        <div class="stats-header white--text">Beteiligung<br>gesamt</div>
        <div class="stats-data white--text">{{ zahlungGesamt }} €</div>
      </v-col>
    </v-row>
  </v-img>
</template>

<style scoped>
.stats-header {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.7px;
}

.stats-data {
  font-size: 24px;
  font-weight: bold;
}

.text-padding {
  padding: 0 20px !important;
}
</style>
